import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import service from "../baseHttpService";
/* eslint @typescript-eslint/no-var-requires: "off" */
const qs = require("qs");
class UnitService {
  GetAssetUnitList() {
    const _input = {
      merchantId: MerchantId(),
      unitType: 3,
      isDeleted: false,
    };
    return service.peakExportAPI.post("/api/Product/GetUnitList", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
}
export default new UnitService();
